import './ContentSection.less';
import React, {useState} from 'react';
import __ from "../../../i18n";
import ChapterItem from "./chapter-item/ChapterItem";
import LessonList from "./lesson-list/LessonList";
import Button from '../../../../bootstrap/components/button/Button';
import Popup from '../../../../bootstrap/components/popup/Popup';
import LessonPreviewer from '../lesson-previewer/LessonPreviewer';
import QuizPreviewer from '../../../tools/quiz-previewer/QuizPreviewer';


export default function ContentSection({course, chapters, lessons, videos, questionGroups, questions}) {
    const [showsVideoPreview, setShowsVideoPreview] = useState(false);

    const [showsQuizPreview, setShowsQuizPreview] = useState(false);

    const previewVideoLessons = lessons.filter(t => t.is_preview === 1 && t.video_id !== null);

    const previewQuizLessons = lessons.filter(t => t.is_preview === 1 && t.quiz_id !== null);

    return <div className="content-section">
        <h2 className="title">{__('Course content')}</h2>
        <div className="sample-lessons">
            {
                previewVideoLessons.length > 0 &&
                <Button
                    appearance="outline-primary"
                    title={__('Try sample lessons')}
                    icon="play-circle"
                    onClick={() => setShowsVideoPreview(true)}
                />
            }
            {
                previewQuizLessons.length > 0 &&
                <Button
                    appearance="outline-primary"
                    title={__('Try sample questions')}
                    icon="question-circle"
                    onClick={() => setShowsQuizPreview(true)}
                />
            }
        </div>
        <div className="content-box">
            {
                chapters.length > 0 &&
                <ul className="season-list">
                    {
                        chapters.map(chapter => <ChapterItem
                            key={chapter.id}
                            chapter={chapter}
                            lessons={lessons.filter(t => t.chapter_id === chapter.id)}
                        />)
                    }
                </ul>
            }
            {
                lessons.some(lesson => lesson.chapter_id === null) &&
                <LessonList lessons={lessons.filter(t => t.chapter_id === null)} />
            }
        </div>
        {
            showsVideoPreview &&
            <Popup name="course-app">
                <LessonPreviewer
                    previewLessons={previewVideoLessons}
                    videos={videos}
                    close={() => setShowsVideoPreview(false)}
                />
            </Popup>
        }
        {
            showsQuizPreview &&
            <Popup className="quiz-preview-list">
                <QuizPreviewer
                    courseId={course.id}
                    lessons={previewQuizLessons}
                    questionGroups={questionGroups}
                    questions={questions}
                    close={() => setShowsQuizPreview(false)}
                />
            </Popup>
        }
    </div>;
}
